import { render, staticRenderFns } from "./registerCampania.vue?vue&type=template&id=2517990b&scoped=true&"
import script from "./registerCampania.vue?vue&type=script&lang=js&"
export * from "./registerCampania.vue?vue&type=script&lang=js&"
import style0 from "./registerCampania.vue?vue&type=style&index=0&id=2517990b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2517990b",
  null
  
)

export default component.exports